import { FETCH_USER_RIGHTS_SUCCESS } from '../actions/UserRolesActions';

export default function userRightsReducer(state = [], action) {
  switch (action.type) {
    case FETCH_USER_RIGHTS_SUCCESS:
      return [...new Set([...action.payload, ...state])];
    default:
      return state;
  }
}
